// src/Dashboard.js
import * as React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import QRCode from "react-qr-code";
import { Html5Qrcode } from "html5-qrcode";
import { useEffect, useRef, useState } from "react";
import { useNotify, useRedirect, useDataProvider } from "react-admin";
import { ListBase, Datagrid, TextField, NumberField, ReferenceField, FunctionField, BooleanField, Pagination } from 'react-admin';
import { getAuthData, httpClient } from "../constant/constant";

const Dashboard = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const qrRef = useRef(null);

  const auth = getAuthData();
  const role = auth?.role;

  const isAdmin = role === "1";
  const isRole2 = role === "2";
  const isRole3 = role === "3";
  const isRole4 = role === "4";

  const [jadwal, setJadwal] = useState([]);
  const [presensi, setPresensi] = useState([]);

  // ===== tanggal =====
  const now = new Date();
  const offset = 8 * 60;
  const todayISO = new Date(now.getTime() + (offset - now.getTimezoneOffset()) * 60000)
  .toISOString()
  .slice(0, 10);

  const hariTanggal = now.toLocaleDateString("id-ID", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  // ===== ambil jadwal piket (ADMIN) =====
  useEffect(() => {
    if (!isAdmin) return;

    const url = `https://sultradata.com/project/antrian-api/api-view.php/records/jadwal_piket_view?filter=tanggal,eq,${todayISO}&order=sesi,asc`;

    httpClient(url, { method: "get" })
      .then((res) => setJadwal(res.json.records))
      .catch((err) => notify("Gagal load jadwal"));
  }, [isAdmin, todayISO, notify]);

  // ===== ambil presensi (ROLE 2 & 3) =====
  useEffect(() => {
    if (!(isRole2 || isRole3)) return;

    dataProvider
      .getList("presensi_pojok", {
        pagination: { page: 1, perPage: 50 },
        sort: { field: "date_created", order: "DESC" },
        filter: { tanggal: todayISO },
      })
      .then(({ data }) => setPresensi(data))
      .catch(() => notify("Gagal load presensi"));
  }, [dataProvider, todayISO, isRole2, isRole3, notify]);

  // ===== QR Scanner =====
  const startScan = async () => {
    if (qrRef.current) return;

    const qr = new Html5Qrcode("qr-reader");
    qrRef.current = qr;

    try {
      await qr.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: 250 },
        (decodedText) => {
          qr.stop().then(() => {
            qrRef.current = null;
            redirect(`/presensi_pojok/create?date=${decodedText}`);
          });
        }
      );
    } catch {
      alert("Gagal membuka kamera");
    }
  };

  const jamPlusSatu = (val) => {
    if (!val) return "-";
    const d = new Date(val.replace(" ", "T"));
    d.setHours(d.getHours() + 1);
    return d.toTimeString().slice(0, 5);
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardHeader
        title={`Selamat Datang ${auth?.username} di Dashboard Antrian`}
      />
      <CardContent>


{/* ================= ROLE PPID ================= */}
{isRole4 && (
  <>
    <h2>Daftar Pengunjung Tamu</h2>

    <ListBase 
      resource="ppid"
      perPage={10} // jumlah row per halaman
      sort={{ field: 'created_at', order: 'DESC' }}
    >
      <>
        <Datagrid bulkActionButtons={false}>
          <TextField source="id" />
          <TextField source="tanggal" />

          <TextField source="nama" />
          <TextField source="tujuan" />
        </Datagrid>

        {/* 👉 Pagination di bawah tabel */}
        <Pagination rowsPerPageOptions={[5, 10, 25, 50]} />
      </>
    </ListBase>
  </>
)}
        {/* ================= ROLE 2 ================= */}
        {isRole2 && (
          <>
            <Button variant="contained" onClick={startScan} sx={{ mb: 2 }}>
              Mulai Scan
            </Button>
            <div id="qr-reader" style={{ width: "100%", minHeight: 300 }} />
          </>
        )}

        {/* ================= ROLE 3 ================= */}
        {isRole3 && (
          <>
            <QRCode
              size={256}
              value={todayISO}
              style={{ maxWidth: 300, marginBottom: 20 }}
            />
          </>
        )}

        {/* ================= PRESENSI ROLE 2 & 3 ================= */}
        {(isRole2 || isRole3) && (
          <>
            <Typography variant="h6" sx={{ mt: 3 }}>
              Presensi Hari Ini
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              {hariTanggal}
            </Typography>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Username</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Jam</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {presensi.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      Belum ada presensi
                    </TableCell>
                  </TableRow>
                ) : (
                  presensi.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.username}</TableCell>
                      <TableCell>{row.status}</TableCell>
                      <TableCell>{jamPlusSatu(row.date_created)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </>
        )}

        {/* ================= ADMIN ================= */}
        {isAdmin && jadwal.length > 0 && (
          <>
            <QRCode size={256} value={todayISO} />

            <div style={{ display: "flex", gap: 40, marginTop: 20 }}>
              <div>
                <b>Petugas Sesi 1</b>
                <ul>
                  <li>{jadwal[0]?.petugas1_nama}</li>
                  <li>{jadwal[0]?.petugas2_nama}</li>
                  <li>{jadwal[0]?.petugas3_nama}</li>
                  <li>{jadwal[0]?.petugas4_nama}</li>
                </ul>
              </div>

              <div>
                <b>Petugas Sesi 2</b>
                <ul>
                  <li>{jadwal[1]?.petugas1_nama}</li>
                  <li>{jadwal[1]?.petugas2_nama}</li>
                  <li>{jadwal[1]?.petugas3_nama}</li>
                  <li>{jadwal[1]?.petugas4_nama}</li>
                </ul>
              </div>
            </div>
          </>
        )}

      </CardContent>
    </Card>
  );
};

export default Dashboard;
